import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';

export const AdminSettingsPage = () => {
  return (
    <>
      <Helmet>
        <title>Settings - AutoScript Admin</title>
      </Helmet>
      <Header title={'Settings'} />

      <Content />
    </>
  );
};
